module.exports = __webpack_public_path__ + "img/new.493157f2.svg";